import {
  EventScheduleFilterItemWrapper,
  EventScheduleFilterList,
} from "./style";

export interface EventScheduleFilterProps {
  open: boolean;
  setOpen: (v: boolean) => void;
  setOtherOpen: (v: boolean) => void;
  filterList: FilterDto[];
  label: string;
  selectedItem: FilterDto;
  setSelectedItem: (v: FilterDto) => void;
  setDate: (v: string) => void;
}

export interface FilterDto {
  id: number;
  name: string;
}
const EventScheduleFilter = ({
  open,
  setOpen,
  setOtherOpen,
  filterList,
  label,
  selectedItem,
  setSelectedItem,
  setDate,
}: EventScheduleFilterProps) => {
  const getPubName = (value: string) => {
    if (value.includes("러너펍")) {
      return value.replace("러너펍", "").trim();
    } else if (value.includes("러너라운지")) {
      const naem = value.replace("러너라운지", "").trim().replace("점", "");
      return `${naem}라운지`;
    }
    return value;
  };
  return (
    <EventScheduleFilterItemWrapper
      onClick={() => {
        setOpen(!open);
        setOtherOpen(false);
      }}
    >
      {getPubName(selectedItem.name)}
      <img src="/image-web/rank/down-arrow.svg" alt="down" />
      {open && (
        <EventScheduleFilterList>
          {filterList.map((item, index) => (
            <div
              className={`item ${selectedItem.id === item.id ? "select" : ""}`}
              key={index}
              onClick={() => {
                setSelectedItem(item);
                setDate("");
              }}
            >
              {item.id === -1 ? label : getPubName(item.name)}
            </div>
          ))}
        </EventScheduleFilterList>
      )}
    </EventScheduleFilterItemWrapper>
  );
};

export default EventScheduleFilter;
